/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".notes-button[_ngcontent-%COMP%]{position:fixed;right:2rem;bottom:2rem;color:#fff;z-index:10}"];
export { styles as styles };
